<template>
  <v-dialog
    v-model="eventTranslatorsDialog"
    transition="dialog-bottom-transition"
    :fullscreen="$vuetify.breakpoint.smAndDown"
    max-width="80%"
    scrollable
  >
    <v-card>
      <v-toolbar
        dark
        flat
        color="secondary"
        scrollable
      >
        <v-btn
          icon
          dark
          @click.native="eventTranslatorsDialog = false"
        >
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title>מתורגמנים</v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <advanced-table
          :headers="headers"
          :filters="filters"
          :sortBy="'callFirst'"
          :descending="true"
          :resource="resource"
          :optionLists="optionLists"
          :doNotSaveState="true"
          :hideExternalToolbar="true"
          :rowAction="addTranslator"
          :defaultRowsPerPage="5"
        />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { format } from "date-fns";
import { getApi } from "@/api";
import AdvancedTable from "@/components/AdvancedTable.vue";

export default {
  data() {
    return {
      headers: [
        {
          text: "שם",
          value: "name",
          align: "right",
          visible: true,
          width: "200",
          displayFunc: (data, key) => {
            return data[key] || "ללא שם";
          }
        },
        {
          text: "תאריך יצירה",
          value: "created",
          align: "right",
          visible: false,
          displayFunc: (data, key) => {
            return format(data[key], "DD-MM-YYYY");
          }
        },
        {
          text: "שפות",
          value: "languages",
          align: "right",
          visible: true,
          displayFunc: (data, key) => {
            let field = "title";
            let array = data[key];
            if (Array.isArray(array) && array.length) {
              return array
                .map(item => {
                  let language = this.entityById("languages", item);
                  return language ? language[field] : "ללא שם";
                })
                .reduce((p, v) => p + ", " + v);
            }
            return "";
          }
        },
        {
          text: "תאריך אימות פרטים",
          value: "lastValidation",
          align: "right",
          visible: true,
          displayFunc: (data, key) => {
            return format(data[key], "DD-MM-YYYY");
          }
        },
        {
          text: "מומלץ",
          value: "recommended",
          align: "right",
          visible: true,
          type: 'ICON',
          displayFunc: (data, key) => {
            return data[key] ? { icon: 'star', color: 'orange' } : { icon: 'mdi-star-outline', color: 'gray' };
          }
        },
        {
          text: "להתקשר ראשון",
          value: "callFirst",
          align: "right",
          visible: true,
          displayFunc: (data, key) => {
            return data[key] ? "כן" : "לא";
          }
        },
        {
          text: "הוספה לאירוע",
          type: "ACTION",
          value: "action",
          name: "addTranslatorToEvent",
          align: "left",
          visible: true,
          icon: "add",
          click: translatorId => {
            return this.addTranslator(translatorId);
          }
        }
      ],
      filters: [
        {
          type: "COMBOBOX",
          label: "שפות",
          model: "languages",
          items: "languages",
          itemText: "title",
          itemValue: "_id",
          active: true
        },
        {
          type: "DATE",
          label: "נוצר אחרי",
          model: "createdAfter",
          active: false
        },
        {
          type: "DATE",
          label: "נוצר לפני",
          model: "createdBefore",
          active: false
        },
        {
          type: "DATE",
          label: "אימות פרטים לפני",
          model: "lastValidationBefore",
          active: false
        },
        {
          type: "TEXT",
          label: "חיפוש חופשי",
          model: "search",
          icon: "search",
          expanded: true,
          active: true
        }
      ]
    };
  },

  computed: {
    eventTranslatorsDialog: {
      get() {
        return this.$store.getters["events/eventTranslatorsDialog"];
      },
      set(isActive) {
        this.$store.commit("events/TOGGLE_EVENT_TRANSLATORS_DIALOG", isActive);
      }
    },
    eventId() {
      return this.$route.params.id;
    },
    languages() {
      return this.$store.getters["entityList"]("languages");
    },
    resource() {
      return this.$store.state.resources["translator"];
    },
    optionLists() {
      return {
        languages: this.languages
      };
    }
  },

  methods: {
    format,
    entityById(entityType, id) {
      return this.$store.getters["entity"](entityType, id);
    },
    addTranslator(translatorId) {
      return new Promise((resolve, reject) => {
        const translatorsForAllEvents = this.$store.getters["events/translatorsForAllEvents"];
        const isAllEventsMode = translatorsForAllEvents && translatorsForAllEvents.length > 1;

        if (isAllEventsMode) {
          let promises = translatorsForAllEvents.map(eventId => {
            return getApi()
              .then(api => {
                let params = {
                  translatorId
                };
                return api.patch(`/events/${eventId}/add-translator`, params);
              });
          });

          Promise.all(promises)
            .then(() => {
              this.$store.dispatch("SHOW_SNACKBAR", {
                text: 'מתורגמן התווסף לכל האירועים בהצלחה',
                color: "success"
              });
              resolve();
            })
            .catch(err => {
              reject(err);
            });
        } else {
          getApi()
            .then(api => {
              let params = {
                translatorId
              };
              return api.patch(`/events/${this.eventId}/add-translator`, params);
            })
            .then(() => {
              this.$store.dispatch("SHOW_SNACKBAR", {
                text: 'מתורגמן התווסף בהצלחה',
                color: "success"
              });
              resolve();
            })
            .catch(err => {
              reject(err);
            });
        }
      });
    }
  },

  components: {
    AdvancedTable
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/events/EventTranslatorsDialog.vue